import { toast } from "react-toastify";
import { useCopyToClipboard } from "usehooks-ts";
import { ClipboardIcon, CpuChipIcon } from "@heroicons/react/24/outline";

import { env } from "../../../../../common/lib/env";
import { Modal } from "../../../../../common/Atoms/Modal";
import { Button } from "../../../../../common/Atoms/Button";
import { Paragraph } from "../../../../../common/Atoms/Typography/Paragraph";

const mcpUrl = `${env.mcpUrl}/mcp`;

interface McpConnectorModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

/** MCP server URL for Claude, ChatGPT and other agents that connect over OAuth. */
export function McpConnectorModal({ open, setOpen }: McpConnectorModalProps) {
  const [, copy] = useCopyToClipboard();

  async function handleCopy() {
    try {
      await copy(mcpUrl);
      toast.success(`Copied to clipboard`, { autoClose: 200 });
    }
    catch {
      toast.error(`Failed to copy to clipboard`);
    }
  }

  return (
    <Modal
      open={ open }
      setOpen={ setOpen }
      title={ `Connect an agent (MCP)` }
      icon={ <CpuChipIcon className={ `text-paidniceGreen-500 h-5 w-5 mr-2` } /> }
    >
      <div className={ `space-y-4` }>
        <Paragraph>
          { `Add this URL as a custom connector (MCP server) in Claude, ChatGPT or another agent. You will be asked to sign in to Paidnice and tick the organisations to connect. Connections are listed under My Account > Connected apps and can be revoked there.` }
        </Paragraph>

        <div className={ `flex items-center justify-between bg-gray-100 rounded-md p-3 break-all` }>
          <code className={ `text-xs text-gray-800 mr-2` }>
            { mcpUrl }
          </code>
          <ClipboardIcon
            className={ `h-5 w-5 shrink-0 text-paidniceGreen-500 cursor-pointer` }
            onClick={ handleCopy }
          />
        </div>

        <div className={ `flex justify-end mt-4` }>
          <Button
            color={ `paidniceGreen` }
            onClick={ () => setOpen(false) }
          >
            { `Done` }
          </Button>
        </div>
      </div>
    </Modal>
  );
}
